// How a person wants to start, chosen on the website (TF-401): the link into /signup carries plan=free or
// plan=trial, and the choice waits in this browser for the company registration, which comes after the
// password e-mail. Opened in another browser, the form simply starts on the trial.

export type StartChoice = 'trial' | 'free';

const KEY = 'teamfolio.signupPlan';

/** What an address carries; an unknown or missing plan says nothing. Pure, so it is tested alone. */
export function startChoiceFrom(search: string): StartChoice | null {
  const plan = new URLSearchParams(search).get('plan');
  return plan === 'free' || plan === 'trial' ? plan : null;
}

export function rememberStartChoice(search: string): void {
  const choice = startChoiceFrom(search);
  if (!choice) return;
  try {
    localStorage.setItem(KEY, choice);
  } catch {
    // Without storage the form starts on the trial, and the person can still choose.
  }
}

export function storedStartChoice(): StartChoice {
  try {
    return localStorage.getItem(KEY) === 'free' ? 'free' : 'trial';
  } catch {
    return 'trial';
  }
}

export function forgetStartChoice(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nothing kept, nothing to forget.
  }
}
